<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Reporte</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="6" md="6" lg="12" xxl="12">
                <CSelect label="Mes" size="sm" :value.sync="selectedMonth" :options="monthOptions"
                  @change="cambiarMes" />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="9">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed caption="Reporte"
          icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'" :actions="true" :myButtons="myButtons"
          @mtd_boleta="mtd_boleta" @mtd_factura="mtd_factura" @mtd_reporte_empresa="mtd_reporte_empresa">
        </CTableWrapper>
      </CCol>
    </CRow>
    <cModalReportTypeDocumentVue :title="modalTypeDocument.title" :boo_modal="modalTypeDocument.modal_form"
      :item="modalTypeDocument.item" :type="modalTypeDocument.type"
      @closeModalReportTypeDocument="closeModalReportTypeDocument" />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "company_name", label: "Empresa", _style: "width:10%;" },
  { key: "facturas_count", label: "Cant Factura", _style: "width:5%;" },
  { key: "boletas_count", label: "Cant Boleta", _style: "width:5%;" },
];

import CTableWrapper from "../shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";
import cModalReportTypeDocumentVue from "./modals/cModalReportTypeDocument.vue";

export default {
  components: {
    CTableWrapper,
    cModalReportTypeDocumentVue,
  },
  data() {
    return {
      prefix: "companies",
      fields,
      data: [],
      today: moment().format("YYYY-MM-DD"),
      filter: {
        init: null,
        end: null,
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      myButtons: [
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "Factura",
          action: "mtd_factura",
          icon: "fab fa-facebook-f",
        },
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "Boleta",
          action: "mtd_boleta",
          icon: "fas fa-bold",
        },
        {
          class: "btn-sm",
          color: "danger",
          tooltip: "Reporte Empresa",
          action: "mtd_reporte_empresa",
          icon: "fas fa-file-pdf",
        }
      ],
      modalTypeDocument: {
        title: "VER DOCUMENTOS",
        modal_form: false,
        item: [],
        type: "",
      },

      //por mes
      selectedMonth: moment().format('MMMM'),
      monthOptions: [
        { value: 'enero', label: 'Enero' },
        { value: 'febrero', label: 'Febrero' },
        { value: 'marzo', label: 'Marzo' },
        { value: 'abril', label: 'Abril' },
        { value: 'mayo', label: 'Mayo' },
        { value: 'junio', label: 'Junio' },
        { value: 'julio', label: 'Julio' },
        { value: 'agosto', label: 'Agosto' },
        { value: 'septiembre', label: 'Septiembre' },
        { value: 'octubre', label: 'Octubre' },
        { value: 'noviembre', label: 'Noviembre' },
        { value: 'diciembre', label: 'Diciembre' }
      ],

    };
  },
  created() {
    moment.locale("es");
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    cambiarMes() {
      this.mtd_data()
    },
    mtd_data() {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/vouchers",
        token: this.$store.getters.get__token,
        params: {
          month: this.selectedMonth,
        },
      })
        .then((response) => {
          this.data = response.data.company_data;
          let index = 1;
          this.data.forEach((item) => {
            item.index = index++;
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    closeModalReportTypeDocument: function () {
      this.modalTypeDocument.modal_form = false;
    },
    mtd_boleta(item) {
      this.modalTypeDocument.modal_form = true;
      this.modalTypeDocument.item = item.campus[0].boletas;
      this.modalTypeDocument.type = "BOLETA";
    },
    mtd_factura(item) {
      this.modalTypeDocument.modal_form = true;
      this.modalTypeDocument.item = item.campus[0].facturas;
      this.modalTypeDocument.type = "FACTURA";
    },
    mtd_reporte_empresa(item) {
      const urlBase = this.$store.getters.get__url;

      const win1 = window.open(
        `${urlBase}/companies/viewpdfReporteDocumentEmpresa/${item.company_uuid}/${this.selectedMonth}`,
        "_blank"
      );

      const win2 = window.open(
        `${urlBase}/companies/viewpdfReporteDocumentHowert/${item.company_uuid}/${this.selectedMonth}`,
        "_blank"
      );

      if (!win1 || !win2) {
        alert("Permita las ventanas emergentes (pop-ups) en su navegador.");
      }
    },


  },
};
</script>

<style lang="scss" scoped></style>